import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    borderRadius: 4,
    overflow: 'hidden',
    boxShadow: '0px 4px 4px 0px #00000040',
    backgroundColor: theme.palette.common.white,
    overflowX: 'auto',
  },
  headerCell: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 400,
    fontSize: 'clamp(12px, 0.9vw, 17px)',
    textAlign: 'center',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
  },
  labelCell: {
    fontWeight: 600,
    color: theme.palette.primary.gray,
    fontSize: 'clamp(10px, 0.9vw, 16px)',
    whiteSpace: 'nowrap',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    borderRight: '2px solid #706E6F',
  },
  dataCell: {
    textAlign: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  totalColumnCell: {
    backgroundColor: '#F5F5F5',
  },
  amount: {
    fontWeight: 400,
    color: theme.palette.primary.gray,
    fontSize: 'clamp(11px, 0.95vw, 17px)',
    whiteSpace: 'nowrap',
  },
  variation: {
    fontSize: 'clamp(9px, 0.8vw, 15px)',
    fontWeight: 600,
  },
  positive: {
    color: theme.palette.success.main,
  },
  negative: {
    color: theme.palette.error.main,
  },
  neutral: {
    color: theme.palette.grey[500],
  },
  rightHeaderCell: {
    backgroundColor: '#F5F5F5',
    fontWeight: 700,
    color: theme.palette.primary.gray,
    fontSize: 'clamp(10px, 0.9vw, 16px)',
    textAlign: 'center',
  },
  rightCell: {
    backgroundColor: '#F5F5F5',
    fontWeight: 600,
    textAlign: 'center',
    color: theme.palette.primary.gray,
    whiteSpace: 'nowrap',
    fontSize: 'clamp(10px, 0.9vw, 16px)',
  },
  totalsRow: {
    '& td': {
      borderRight: 'none',
      borderBottom: '2px solid #706E6F',
      backgroundColor: '#F5F5F5 !important',
    },
  },
}));

export default useStyles;
